<template>
	<inertia-head title="Set Password" />
	<div v-if="hasError" class="alert alert-danger">
		<h3 class="alert-heading fs-5 fw-bold mb-1">Invalid Link!</h3>
		<p class="mb-0">Cannot set password. Link is either used or expired.</p>
	</div>
	<form v-else @submit.prevent="submit">
		<div class="form-floating mb-4">
			<input
				v-model="form.password"
				:class="{ 'is-invalid': form.errors.password }"
				type="password"
				class="form-control"
				id="email"
				placeholder="Enter your password"
			/>
			<label class="form-label" for="password">Password</label>
			<div v-if="form.errors.password" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.password }}
			</div>
		</div>
		<div class="form-floating mb-4">
			<input
				v-model="form.password_confirmation"
				:class="{ 'is-invalid': form.errors.password_confirmation }"
				type="password"
				class="form-control"
				id="password_confirmation"
				placeholder="Enter your password_confirmation"
			/>
			<label class="form-label" for="password_confirmation">
				Confirm Password
			</label>
			<div v-if="form.errors.password_confirmation" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.password_confirmation }}
			</div>
		</div>
		<div class="row g-sm mb-4">
			<div class="col-12 mb-2">
				<button
					:disabled="form.processing"
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
				>
					<span v-if="form.processing">Validating...</span>
					<span v-else>Save password</span>
				</button>
			</div>
		</div>
	</form>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import GuestLayout from '../../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	props: {
		hash: String,
		hasError: Boolean,
	},
	setup(props) {
		const form = useForm({
			password: null,
			password_confirmation: null,
			hash: props.hash,
		})

		const submit = () => {
			form.post(route('post.set-password'))
		}

		return {
			form,
			submit,
		}
	},
}
</script>
